import axios from "axios";
import { API } from "../utilities/api.config";

function loadRssFed() {
  const feedUrl = API.FEED;
  return (dispatch) => {
    dispatch({
      type: "FETCH_FEED_REQUESTED",
    });
    axios
      .get(feedUrl)
      .then((response) => {
        dispatch({
          type: "FETCH_FEED_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "FETCH_FEED_FAIL",
          payload: error,
        });
      });
  };
}

export const feedAction = {
  loadRssFed,
};



// WEBPACK FOOTER //
// ./src/actions/feed.action.js